import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import AdSlot from "@/components/AdSlot";
import Seo from "@/components/Seo";

export default function SeoPage() {
  const { slug } = useParams();
  const { lang, L } = useI18n();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setData(null); setNotFound(false);
    api.get(`/seo/pages/${slug}`).then(({ data }) => setData(data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="max-w-xl mx-auto px-5 py-24 text-center"><h1 className="font-serif text-3xl">Pagina non trovata</h1><Link to="/" className="text-rose-500 mt-4 inline-block">Torna alla home</Link></div>;
  if (!data) return <div className="min-h-[50vh] flex items-center justify-center text-charcoal/50">Caricamento...</div>;

  const { page, items } = data;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: L(page, "title"),
    description: L(page, "meta") || L(page, "intro"),
    itemListElement: items.slice(0, 20).map((p, i) => ({
      "@type": "ListItem", position: i + 1,
      name: `${p.brand} ${L(p, "name")}`, url: p.affiliate_url,
    })),
  };
  return (
    <div>
      <Seo title={L(page, "title")} description={L(page, "meta") || L(page, "intro")} jsonLd={jsonLd} />
      <div className="olive-bg text-white">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-14">
          <p className="text-xs uppercase tracking-[0.3em] text-white/80 font-semibold">Guida Velyrea</p>
          <h1 className="mt-3 font-serif text-4xl sm:text-5xl max-w-3xl">{L(page, "title")}</h1>
          <p className="mt-4 max-w-2xl text-white/90 text-lg">{L(page, "intro")}</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-10">
        <AdSlot format="leaderboard" className="mb-8" />
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="seo-products">
          {items.map((p, i) => <ProductCard key={p.sku} product={p} index={i} />)}
        </div>
        <div className="mt-12 text-center">
          <Link to="/quiz" className="inline-flex rounded-full bg-rose-400 hover:bg-rose-500 text-white font-semibold px-8 py-3.5 transition-colors">Scopri i tuoi match personali</Link>
        </div>
      </div>
    </div>
  );
}
